<span *ngIf="inputText" [ngStyle]="{'display': block ? 'block':'inline', 'color': textColor+'!important'}" data-cy="truncate-text">
  {{ displayText }}
  <span *ngIf="!isExpanded && inputText?.split(' ').length > limit" (click)="toggleText()" class="show-more">
    {{showEllipsis ? '&hellip;' : 'Read more'}}
  </span>
  <span *ngIf="isExpanded" (click)="toggleText()" class="show-less">
    {{showEllipsis ? '&NestedLessLess;' : 'Show less'}}
  </span>
</span>